import React, { useEffect, useState } from 'react'
import { Field, Form, Formik } from 'formik'
import { Button, Grid, MenuItem } from '@material-ui/core'
import { TextField } from 'formik-material-ui'
import { metodoPrograma } from '../../../components/api'

export const Cadastro = ({ objeto, voltar }) => {
  const [pais, setPais] = useState([])
  const initialValues = {
    cdPais: objeto ? objeto[0] : '',
    ufEstado: objeto ? objeto[1] : '',
    nmEstado: objeto ? objeto[2] : '',
  }

  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) voltar()
  }

  useEffect(() => {
    const fetchPaises = async () => {
      const res = await metodoPrograma('listaPais', {})
      console.log('res', res)
      if (res.status) {
        setPais(res.lista)
      }
    }
    fetchPaises()
  }, [])

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={2}>
              <Field
                component={TextField}
                label="País"
                name="cdPais"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
                select
              >
                {pais.map((item) => (
                  <MenuItem value={item[0]} key={item[1]}>
                    {item[1]}
                  </MenuItem>
                ))}
              </Field>
            </Grid>
            <Grid item xs={2}>
              <Field
                component={TextField}
                label="UF"
                name="ufEstado"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={8}>
              <Field
                component={TextField}
                label="Estado"
                name="nmEstado"
                disabled={isSubmitting}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}
